import * as React from 'react';
import cx from 'classnames';

import { IncidentComponentStatus } from 'containers/incident/types';
import { StatusSelectValues } from './StatusSelectValues';

import { StatelessSelect, ItemType } from '@atlaskit/single-select';
const styles = require('./styles.scss');

export interface Props {
  status: IncidentComponentStatus;
  newStatus?: IncidentComponentStatus;
  isOverridden: boolean;
  isBasedOn: boolean;
  basedOnStatus?: IncidentComponentStatus;
  visible: boolean;
  onSelected?: (new_status: IncidentComponentStatus) => void;
  setOverride?: (override: boolean) => void;
  statusFieldName: string;
  stacked?: boolean;
  use_adg3?: boolean;
  withLabel?: boolean;
}

interface State {
  isOpen: boolean;
  newStatus: IncidentComponentStatus;
  isOverridden: boolean;
}

export default class ComponentStatusPicker extends React.Component<
  Props,
  State
> {
  static defaultProps = {
    stacked: false,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      isOpen: false,
      newStatus: props.newStatus || props.status,
      isOverridden: props.isOverridden,
    };
  }

  componentWillReceiveProps(newProps: Props) {
    const newStatus = newProps.newStatus || this.state.newStatus;
    const isOverridden = newProps.isOverridden;

    this.setState({
      newStatus,
      isOverridden,
    });
  }

  selectedItem = () => {
    const targetStatus =
      this.props.isBasedOn && !this.state.isOverridden
        ? this.props.basedOnStatus
        : this.state.newStatus || this.props.status || this.props.basedOnStatus;
    return StatusSelectValues[0].items.find(it => it.value === targetStatus);
  };

  toggleOpen = ({ isOpen }: { isOpen: boolean }) => this.setState({ isOpen });

  setOverride = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.setOverride && this.props.setOverride(event.target.checked);
    this.setState({
      isOverridden: event.target.checked,
    });

    if (!event.target.checked) {
      this.props.onSelected && this.props.onSelected(this.props.basedOnStatus!);
      this.setState({
        newStatus: this.props.basedOnStatus!, // reset to server status on unselected
      });
    }
  };

  onSelected = (val: ItemType) => {
    this.setState({
      newStatus: val.value as IncidentComponentStatus,
    });
    this.props.onSelected &&
      this.props.onSelected(val.value as IncidentComponentStatus);
  };

  overrideStatus = () => {
    const checkbox = (
      <label className={styles.overrideStatus}>
        <input
          type="checkbox"
          onChange={this.setOverride}
          checked={this.state.isOverridden}
        />
        <span>Override</span>
      </label>
    );
    return this.props.isBasedOn ? checkbox : null;
  };

  get isDisabled() {
    return this.props.isBasedOn ? !this.state.isOverridden : false;
  }

  hiddenField() {
    if (!this.props.visible) {
      return null;
    }
    return (
      <input
        type="hidden"
        name={this.props.statusFieldName}
        value={
          this.props.isBasedOn
            ? this.state.isOverridden
              ? this.state.newStatus
              : ''
            : this.state.newStatus
        }
      />
    );
  }

  render() {
    const outerClass = cx(
      styles.statusDropdown,
      this.props.visible ? null : styles.isHidden,
      this.props.stacked ? styles.columnReversed : null,
    );

    const innerClass = cx(
      'incident-status-dropdown',
      'component-status-picker', // must leave this handle for capybara
      { 'incident-status-dropdown-open': this.state.isOpen },
      styles.statelessSelect,
    );
    return (
      <div className={outerClass}>
        {this.overrideStatus()}
        <div className={innerClass}>
          {this.hiddenField()}
          <StatelessSelect
            shouldFitContainer
            selectedItem={this.selectedItem()}
            items={StatusSelectValues}
            isDisabled={this.isDisabled}
            onOpenChange={this.toggleOpen}
            isOpen={this.state.isOpen}
            onSelected={this.onSelected}
          />
        </div>
      </div>
    );
  }
}
